module.exports = __webpack_public_path__ + "static/media/ask-oceans.d9951479.jpg";